<template>
    <div class="terms-wrapper" :class="{'with-confirm': withConfirm}">
        <span class="top"></span>
        <div class="terms-page flex column">
            <div class="tc-header w-full flex row" v-if="withConfirm">
                <img class='cross' src="@/assets/cross.svg" alt="cross" @click="closePopup()"/>
            </div>
            <div class='content' :id="`content-of-${view}`" v-html="terms.text"></div>

            <div v-if="!loaded" class="flex justify-center align-center">
                <LoaderPopup :hideHeader="true" message="Loading.."/>
            </div>
            <div class='w-full flex column gap-10 pt-10' 
                :class="`${!bottomReached ? 'not-bottom': ''}`" v-if="withConfirm && loaded" @click="clickReadOption()">
                <div class="checkbox flex row gap-10 align-center">
                    <input class='checkbox-input' type="checkbox" @change="checkBoxTrigger" :disabled="!bottomReached">
                    <div>{{ props.buttonText || 'I Read Terms and Conditions and ready to proceed' }}</div>
                </div>
                <button class='button' :disabled="buttonDisabled" @click="confirmTC">Proceed</button>
            </div>
        </div>
        <Footer  v-if="!withConfirm"/>
    </div>
</template>

<script setup>
    import { ref, onMounted, defineEmits, watch } from 'vue';
    import API from '../api/index.js'
    import { useStore } from 'vuex';
    import LoaderPopup from '@/components/LoaderPopup.vue';
    import Footer from '@/components/Footer.vue'
    const emit = defineEmits(['confirmTC', 'closePopup']);
    const props = defineProps(['withConfirm', 'view', 'buttonText']);
    const buttonDisabled = ref(true);

    const headers = {
        'terms': 'Terms and Conditions',
        'terms-of-use': 'Terms of Use',
        'privacy': 'Privacy Policy',
        'agreement': 'Agreement',
    }

    const store = useStore();
    const terms = ref([]);
    const loaded = ref(false);
    const contentPage = ref(null);
    const bottomReached = ref(false);


    async function loadTerms(){
        loaded.value = false;
        document.title = headers[props.view];
        const responseData = await API.getPageContent(props.view);
        const data = responseData.pages[0];

        terms.value = data;
        if (terms.value.structure) {
            terms.value.structure = JSON.parse(terms.value.structure);
        }
        loaded.value = true;
        // window.scrollTo(0, 0);
        let x = document.querySelector('.top');
        if (x) {
            x.scrollIntoView({ behavior: 'smooth' });
        }
    }
  
    onMounted( async () => {
        await loadTerms();
        
        if (!props.withConfirm) {
            return
        }

        contentPage.value = document.querySelector(`#content-of-${props.view}`)
        contentPage.value.addEventListener('scroll', () => {
            const atBottom = contentPage.value.scrollTop + contentPage.value.clientHeight >= contentPage.value.scrollHeight - 10; // -10 for tolerance
            if (atBottom) {
                bottomReached.value = true;
            }
        });
    });
    function clickReadOption(){
        if (!bottomReached.value) {
            store.dispatch('addNotification', {
                type: 'success',
                text: 'Please read the full document first before proceeding.'
            });
            API.userEvent({page: props.view, event: 'click checkmark before scrolling down'})
        }
    }

    function closePopup(){
        emit('closePopup');
    }
    function checkBoxTrigger(event) {
        API.userEvent({page: props.view, checkboxChecked: event.target.checked})
        buttonDisabled.value = !event.target.checked
    }


    function confirmTC(){
        emit('confirmTC');
    }

  

    function checkScroll(event){
        console.log('scrool', event)
    }

    watch(() => props.view, async (newVal, oldVal) => {
        if (newVal !== oldVal) {
            await loadTerms();
        }
    })
</script>


<style lang="scss" scoped>
    .terms-page {
        margin: 70px;
        padding: 30px;
        color: black;
        text-align: left;
        position: relative;
        background: white;
        border: 1px solid var(--border-color);
        height: fit-content;
        border-radius: 10px;
        min-width: 500px;
        min-height: 500px;
        font-weight: normal;
        padding-bottom: 30px;
        max-width: 1500px;
        margin-left: auto;
        margin-right: auto;
        box-sizing: border-box;
    }
    .terms-wrapper:not(.with-confirm) {
        padding: 20px;
    }
    .with-confirm .terms-page {
        margin-top: 0;
        margin-bottom: 0;
        border-radius: 0;
        border-right: none;
        padding-right: 0;
    }
    .links a {
        color: rgb(75 85 99);
        transition: all 0.3s ease;
        &:hover {
            color: var(--primary-color);
        }
    }
    .tc-header {
        justify-content: center;
        align-items: center;
    }
    h3 {
        font-size: 24px;
        font-weight: 600;
        margin: 0;
    }
    .cross {
        cursor: pointer;
        position: absolute;
        right: 20px;
        top: 20px;
    }
    button {
        width: fit-content;
    }

    .with-confirm .content {
        max-height: 77vh;
    }

    .content {
        overflow-y: auto ;
        &:deep(h2) {
            font-size: 2.5rem;
            margin-bottom: 20px;
        }
        &:deep(h3) {
            font-size: 2rem;
            margin-bottom: 10px;
            padding-left: 30px;

            strong {
                font-weight: 500;
            }
            position: relative;
            &::before {
                content: '';
                display: inline-block;
                position: absolute;
                left: 0;
                width: 5px;
                height: 100%;
                background-color: rgb(37 99 235);
            }
        }
        &:deep(p) {
            margin:  0;
            margin-bottom: 10px;
            font-size: 16px;
        }
    }
    .not-bottom {
        > * {
            pointer-events: none;
        }
    }
    .checkbox-input {
        padding: 10px;
    }
</style>